import Admin from "../Admin";
import React from "react";
import CardAdminProviderList from "../../../Component/Card/Admin/Provider/CardAdminProviderList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class ProviderList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminProviderList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/provider",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Providers" buttons={buttons} />;
  }
}
